/* Schnellkauf für Karten ohne Mix & Match (snippets/rf-schnellkauf.liquid), 22. Oktober 2026.
 * Nur Auf- und Zuklappen der Tafel; das Hinzufügen erledigt das product-form des Themes. */
(function () {
  function zu(k) {
    if (!k) return;
    k.classList.remove('is-auf');
    var b = k.querySelector('[data-rf-sk-auf]');
    if (b) b.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', function (e) {
    var auf = e.target.closest('[data-rf-sk-auf]');
    var offen = document.querySelectorAll('.rf-sk.is-auf');
    var k = e.target.closest('.rf-sk');
    offen.forEach(function (o) { if (o !== k) zu(o); });
    if (!auf) return;
    e.preventDefault();
    k.classList.add('is-auf');
    auf.setAttribute('aria-expanded', 'true');
    var erster = k.querySelector('.rf-sk__plus');
    if (erster) erster.focus({ preventScroll: true });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var k = e.target.closest && e.target.closest('.rf-sk.is-auf');
    if (!k) return;
    zu(k);
    var b = k.querySelector('[data-rf-sk-auf]');
    if (b) b.focus();
  });
  // Zahlen im Knopf nach jeder Korb-Änderung nachziehen (Hinzufügen hier, Ändern in der Schublade)
  var t = null;
  function zaehlen() {
    clearTimeout(t);
    t = setTimeout(function () {
      if (!document.querySelector('.rf-sk')) return;
      fetch((window.theme && theme.routes && theme.routes.cart_url ? theme.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var jeV = {};
          c.items.forEach(function (i) { jeV[i.variant_id] = (jeV[i.variant_id] || 0) + i.quantity; });
          document.querySelectorAll('.rf-sk').forEach(function (k) {
            var knopf = k.querySelector('.rf-sk__knopf'), n = 0;
            k.querySelectorAll('.rf-sk__form').forEach(function (f) {
              var id = f.querySelector('[name="id"]').value, m = jeV[id] || 0, plus = f.querySelector('.rf-sk__plus');
              n += m;
              if (plus) { plus.textContent = m > 0 ? m : '+'; plus.classList.toggle('is-drin', m > 0); }
            });
            if (!knopf) return;
            knopf.classList.toggle('is-drin', n > 0);
            knopf.querySelector('.rf-sk__zahl').textContent = n > 0 ? n : '+';
            knopf.querySelector('.rf-sk__text').textContent = n > 0 ? 'im Warenkorb' : 'In den Warenkorb';
          });
        })
        .catch(function () {});
    }, 250);
  }
  ['theme:cart:added', 'theme:cart:refresh', 'theme:cart:loaded'].forEach(function (ev) { document.addEventListener(ev, zaehlen); });
})();
